import request from "@/utils/request";
import { Message } from "element-ui";

export function getInfo(token) {
  return request({
    url: "/vue-element-admin/user/info",
    method: "get",
    params: { token }
  });
}

//刷新token
export function refreshToken() {
  return request({
    url: "/v1.0/iwrs/user/refresh_token",
    method: "post",
    data: {
      token: sessionStorage.getItem("iwrs_refresh_token")
    }
  }).then(res => {
    if (res && res.code === 0) {
      sessionStorage.setItem("iwrs_token", res.data.token);
      sessionStorage.setItem("iwrs_refresh_token", res.data.refresh_token);
      window.location.reload()
    } else {
      Message.error(res.msg);
    }
  });
}

export function infoMation(params) {
  return request({
    url: "/v1.0/iwrs/user/detail",
    method: "get",
    params
  });
}

export function logout() {
  return request({
    url: "/vue-element-admin/user/logout",
    method: "post"
  });
}

export function login(data) {
  return request({
    url: "/v1.0/iwrs/user/login",
    method: "post",
    data
  });
}

export function updatePass(data) {
  return request({
    url: "/v1.0/iwrs/user/update/pwd",
    method: "put",
    data
  });
}

// 更新个人信息
export function updateInfo(data) {
  return request({
    url: "/v1.0/iwrs/user/update",
    method: "put",
    data
  });
}

// 角色和权限
export function myDetail(query) {
  return request({
    url: "/v1.0/iwrs/project_user/my_detail",
    method: "get",
    params: query
  });
}

export function batch_add_check(data) {
  return request({
    url: "/v1.0/iwrs/project_user/batch/add/check",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data
  });
}

// 批量增加用户
export function batch_add(data) {
  return request({
    url: "/v1.0/iwrs/project_user/batch/add",
    method: "post",
    data
  });
}

// 发送验证码
export function sendVerifyCode(data) {
  return request({
    url: "/v1.0/iwrs/user/send_verify_code",
    method: "post",
    data
  });
}

// 修改密码
export function modifyPwd(data) {
  return request({
    url: "/v1.0/iwrs/user/password_retrieve",
    method: "post",
    data
  });
}
